import { Box } from '@factorialco/deprecated-design-system'
import { PayrollLegalEntityChangeInfoEmployeeGroupFragment } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'
import legalEntitiesCollection from 'modules/core/store/collections/legalEntities'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import { employeeDataUpdatesTranslation } from 'modules/bookkeepers/lib/dynamicTranslations'
import type IncidenceChanges from 'modules/bookkeepers/store/collections/changes'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'

interface DataChangeInfoProps {
  incidenceDetailModel: IncidenceDetail
  incidenceChangesCollection: IncidenceChanges
  effective_date?: string | null
  employeeGroup: PayrollLegalEntityChangeInfoEmployeeGroupFragment[]
}

const LegalEntityChangeInfo = ({
  incidenceDetailModel,
  incidenceChangesCollection,
  effective_date,
  employeeGroup,
}: DataChangeInfoProps) => {
  const newIncidenceDetail = incidenceDetailModel.toJS()
  const newLegalEntity = legalEntitiesCollection.get(newIncidenceDetail.legal_entity_id)
  const newEmployeeGroup = employeeGroup.find(
    (group) => group.id === newIncidenceDetail.employee_group_id
  )
  // Last incidence is current incidence. Thus, we pick the one before the last to check the change
  const sortedIncidences = orderBy(incidenceChangesCollection.toJS(), 'id', 'desc')
  const oldIncidenceDetail = sortedIncidences.length > 1 ? sortedIncidences[1] : null
  const oldLegalEntity = oldIncidenceDetail
    ? legalEntitiesCollection.get(oldIncidenceDetail.legal_entity_id)
    : undefined

  const oldEmployeeGroup = oldIncidenceDetail
    ? employeeGroup.find((group) => group.id === oldIncidenceDetail.employee_group_id)
    : undefined

  return (
    <Box gap="s16">
      <IncidenceDetailDataChangeLine
        label={i18n.t('bookkeepers.incidence.table.effective_date')}
        newValue={effective_date ?? null}
      />
      <IncidenceDetailDataChangeLine
        label={employeeDataUpdatesTranslation('legal_entity_id')}
        newValue={newLegalEntity?.name || null}
        oldValue={oldLegalEntity?.name}
      />
      <IncidenceDetailDataChangeLine
        label={employeeDataUpdatesTranslation('employee_group_id')}
        newValue={newEmployeeGroup?.name || null}
        oldValue={oldEmployeeGroup?.name}
      />
    </Box>
  )
}

export default LegalEntityChangeInfo
